import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const DocumentIcon = ({
  title = 'Document',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    {/* prettier-ignore */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.833 2.833H5.5v18.334h13V10.5H12a1.167 1.167 0 01-1.167-1.167v-6.5zm2.333 1.65l3.684 3.684h-3.684V4.483zm7.667 4.86v12.99c0 .645-.522 1.167-1.166 1.167H4.332a1.167 1.167 0 01-1.167-1.167V1.667C3.167 1.022 3.69.5 4.333.5h7.651c.31-.004.614.115.84.342l7.667 7.666c.226.226.345.528.342.835z"
    />
  </CreateIconComponent>
);

export default DocumentIcon;
